import React from 'react';
import { twMerge } from 'tailwind-merge';
type EyebrowTone = 'light' | 'dark' | 'red';
interface EyebrowProps {
  children: React.ReactNode;
  tone?: EyebrowTone;
  className?: string;
}
const toneClasses: Record<EyebrowTone, {
  text: string;
  rule: string;
}> = {
  light: {
    text: 'text-brand-deep',
    rule: 'bg-brand'
  },
  dark: {
    text: 'text-brand-bright',
    rule: 'bg-brand'
  },
  red: {
    text: 'text-white',
    rule: 'bg-white'
  }
};
export function Eyebrow({
  children,
  tone = 'light',
  className
}: EyebrowProps) {
  const t = toneClasses[tone];
  return <p className={twMerge('flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.14em] sm:text-xs sm:tracking-[0.18em]', t.text, className)} data-id="element-58" data-mp="16uf5vb1g2tlu">
      <span aria-hidden="true" className={twMerge('hidden h-[2px] w-7 shrink-0 sm:block', t.rule)} data-id="element-59" data-mp="xxocx7i6vuvh" />
      {children}
    </p>;
}